import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { doc, getDoc, collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import RequestPaymentButton from "../components/RequestPaymentButton";
import "../styles/dashboard.css";

const Dashboard = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [userPosts, setUserPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const userId = auth.currentUser?.uid;
      if (!userId) {
        navigate("/login");
        return;
      }

      try {
        setLoading(true);

        // Check if user data and posts are cached
        const cachedUserInfo = JSON.parse(localStorage.getItem(`user_${userId}`));
        const cachedUserPosts = JSON.parse(localStorage.getItem(`user_posts_${userId}`));

        if (cachedUserInfo) {
          setUserInfo(cachedUserInfo);
        } else {
          // Fetch User Information from Firestore
          const userDoc = await getDoc(doc(db, "users", userId));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const userInfoData = {
              username: userData.username || "N/A",
              email: auth.currentUser.email || "",
              displayName:
                auth.currentUser.displayName ||
                userData.displayName ||
                "No Display Name",
              photoURL:
                auth.currentUser.photoURL ||
                userData.photoURL ||
                "https://via.placeholder.com/100",
              upiId: userData.upiId || "Not Provided",
            };
            setUserInfo(userInfoData);
            localStorage.setItem(`user_${userId}`, JSON.stringify(userInfoData)); // Cache user data
          }
        }

        if (cachedUserPosts) {
          setUserPosts(cachedUserPosts);
        } else {
          // Query User's Posts
          const postsQuery = query(
            collection(db, "posts"),
            where("userId", "==", userId),
            orderBy("createdAt", "desc")
          );
          const postsSnapshot = await getDocs(postsQuery);

          if (!postsSnapshot.empty) {
            const userPostsData = postsSnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
              createdAt: doc.data().createdAt?.toDate().toISOString() || "No Timestamp",
            }));
            setUserPosts(userPostsData);
            localStorage.setItem(`user_posts_${userId}`, JSON.stringify(userPostsData)); // Cache user posts
          } else {
            console.log("No posts found for this user.");
            setUserPosts([]);
            localStorage.setItem(`user_posts_${userId}`, JSON.stringify([])); // Cache empty array if no posts
          }
        }
      } catch (error) {
        console.error("Error fetching user data or posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  return (
    <div className="dashboard-container">
      <header>
        {loading ? (
          <div>Loading...</div>
        ) : userInfo ? (
          <div className="user-info">
            <img src={userInfo.photoURL} alt="Profile" className="profile-picture" />
            <p>
              <strong>Display Name:</strong> {userInfo.displayName}
            </p>
            <p>
              <strong>Username:</strong> {userInfo.username}
            </p>
            <p>
              <strong>Email:</strong> {userInfo.email}
            </p>
            <p>
              <strong>UPI ID:</strong> {userInfo.upiId}
            </p>
          </div>
        ) : (
          <p>Unable to load user information.</p>
        )}
      </header>

      <div className="quick-actions">
        <button className="action-button" onClick={() => navigate("/createpost")}>
          Create New Post
        </button>
        <button className="action-button" onClick={() => navigate("/edit-profile")}>
          Edit Profile
        </button>
        <button className="action-button" onClick={() => navigate("/terms")}>
          Terms and Conditions for Payments
        </button>
      </div>

      <div className="user-posts">
        <h3>Your Posts</h3>
        {userPosts.length > 0 ? (
          <ul>
            {userPosts.map((post) => (
              <li key={post.id} className="user-post-item">
                <div onClick={() => navigate(`/post/${post.id}`)}>
                  <h4>{post.title}</h4>
                  <div
                    className="content"
                    dangerouslySetInnerHTML={{
                      __html: post.content?.substring(0, 100) || "No content available",
                    }}
                  ></div>
                  <small>
                    {post.createdAt !== "No Timestamp"
                      ? new Date(post.createdAt).toLocaleString()
                      : "No Timestamp"}
                  </small>
                  <p>
                    <strong>Likes:</strong> {post.likeCount || 0}
                  </p>
                </div>
                <div className="post-actions">
                  <RequestPaymentButton
                    postId={post.id}
                    likes={post.likeCount}
                    onPaymentRequested={(updatedPostId) => {
                      console.log(`Payment requested for post: ${updatedPostId}`);
                    }}
                  />
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No posts created yet. Start creating!</p>
        )}
      </div>

     <p onClick={()=> navigate("/privacypolicy")}>Privacy Policy</p>
    </div>
  );
};

export default Dashboard;
